import React from 'react';
import ReactDOM from 'react-dom';
import AuthForm from './AuthForm';
import { SignInModalTab } from '../SignInModal/types';

const renderAuthForm = (
  returnUrl?: string,
  defaultTabOverride?: SignInModalTab,
  trackingOptions?: { location: string },
  prePopulatedEmail?: string,
  useCustomHero?: boolean
) => {
  const mountNode = document.querySelector('[react-render-target="auth-form-container"]');
  if (mountNode)
    ReactDOM.render(
      <AuthForm
        returnUrl={returnUrl}
        defaultTabOverride={defaultTabOverride}
        trackingOptions={trackingOptions}
        prePopulatedEmail={prePopulatedEmail}
        useCustomHero={useCustomHero}
      />,
      mountNode
    );
  else console.warn('missing render target: AuthForm');
};

export const initAuthForm = (
  returnUrl?: string,
  defaultTabOverride?: SignInModalTab,
  trackingOptions?: { location: string },
  prePopulatedEmail?: string,
  useCustomHero?: boolean
) => {
  renderAuthForm(returnUrl, defaultTabOverride, trackingOptions, prePopulatedEmail, useCustomHero);
};
